import { from } from "rxjs";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseSkipProcessSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { IdQuickSkip } from "../../../quick-skip-dialog/IdQuickSkip";
export var pathConstructionInProgress = function (action, state$) {
    return from([
        actionOngoingPurchaseSkipProcessSelect(IdQuickSkip.Construction),
        actionModalOpen(IdModal.SkipProcess),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathConstructionInProgress.ts
// module id = 853
// module chunks = 3